import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReviewsSort } from 'features/reviews';
import { Typography, Dropdown, DropdownItem } from 'fronton-react';

import { starAtTitle, scoreAtTitle, sortingsDropdown } from './styles';

export const ReviewsWithScoreLabel: React.FC<{ filteredByScores: number[] }> = ({ filteredByScores }) => {
  const { t } = useTranslation();

  return (
    <div data-qa="reviews-label-with-scores-at-top_mf-pdp">
      <Typography variant="s" size="subtitle">
        {t('reviews.ui.with-rating')}{' '}
      </Typography>
      <span>
        {filteredByScores.map((score, idx, arr) => {
          const separator = arr.length - idx > 1 ? ',' : '';
          const key = `reviews-score-label-${score}`;
          return (
            <span className={scoreAtTitle} key={key} data-qa={key}>
              {score}&nbsp;
              <Star />
              {separator}
            </span>
          );
        })}
      </span>
    </div>
  );
};

const Star: React.FC = () => {
  return (
    <svg
      className={starAtTitle}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11.2516L11.326 14L10.178 8.82L14 5.33474L8.967 4.88526L7 0L5.033 4.88526L0 5.33474L3.822 8.82L2.674 14L7 11.2516Z"
        fill="#333333"
      />
    </svg>
  );
};

export const SortingDropdown: React.FC<{
  sortedByLabel: string;
  sortedByValue: ReviewsSort;
  onSortChange: (selected: string | string[] | null) => void;
  sortingLabelValuesMap: Map<ReviewsSort, string>;
  isMobile?: boolean;
}> = ({ sortedByLabel, sortedByValue, sortingLabelValuesMap, onSortChange, isMobile }) => {
  return (
    <div className={sortingsDropdown}>
      <Dropdown
        size="l"
        mobile={isMobile ? 'full-screen' : false}
        data-qa="reviews-sorting-dropdown-at-top_mf-pdp"
        value={sortedByLabel}
        onSelect={onSortChange}
        closeOnSelect
        defaultSelected={sortedByValue}
      >
        {Array.from(sortingLabelValuesMap).map(([value, label]) => {
          return <DropdownItem key={value} value={value} text={label} selected={sortedByValue === value} />;
        })}
      </Dropdown>
    </div>
  );
};
